// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3L_xC","rootSuccess":"CompleteLink_rootSuccess__Z_IEI","rootFailure":"CompleteLink_rootFailure__dsYOY","isDisabled":"CompleteLink_isDisabled__KWMU_"};